import { render, staticRenderFns } from "./EtsyListingsShopTable.vue?vue&type=template&id=2a853a8c&scoped=true"
import script from "./EtsyListingsShopTable.vue?vue&type=script&lang=js"
export * from "./EtsyListingsShopTable.vue?vue&type=script&lang=js"
import style0 from "./EtsyListingsShopTable.vue?vue&type=style&index=0&id=2a853a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a853a8c",
  null
  
)

export default component.exports